import firebase from "../../config/fbConfig";
import { loggedInProfileActions } from "../actions/loggedInProfileActions";
import { LOGIN_SUCCESS, USER_LOGGED_IN } from "../actions/types";

class Firebase {
  constructor() {
    this.auth = firebase.auth();
    this.auth_ = firebase.auth;
    this.database = firebase.database();
    this.functions = firebase.functions();  
    this.storage = firebase.storage();
    // setPersistence is now handled in fbConfig.js immediately after
    // firebase.initializeApp() — that is the correct place to set it,
    // before any auth operations can occur.
  }

  login(email, password) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  logOut() {
    this.auth.signOut();
    sessionStorage.removeItem('reAuthRequired');
    sessionStorage.removeItem('cachedTotpSecret');
  }

  async register(name, email, password) {
    await this.auth.createUserWithEmailAndPassword(email, password);
    this.auth.currentUser.updateProfile({
      displayName: name
    });
  }

  getCurrentUsername() {
    return this.auth.currentUser.displayName;
  }
}

export default new Firebase();
//////////////////////////////////////////////////////////////////////////////////////////
// import firebase from "../../config/fbConfig";
// import { loggedInProfileActions } from "../actions/loggedInProfileActions";
// import { LOGIN_SUCCESS, USER_LOGGED_IN } from "../actions/types";

// class Firebase {
//   constructor() {
//     this.auth = firebase.auth();
//     this.auth_ = firebase.auth;
//     this.database = firebase.database();

//     // Set LOCAL persistence immediately on SDK init — before any sign-in can occur.
//     // This ensures firebase:authUser is written to localStorage (not sessionStorage),
//     // so the session survives page reloads after TOTP re-authentication.
//     this.auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
//       .then(() => console.log('✅ Firebase persistence set to LOCAL'))
//       .catch(e => console.warn('⚠️ Persistence error:', e));
//   }

//   login(email, password) {
//     return this.auth.signInWithEmailAndPassword(email, password);
//   }

//   logOut() {
//     this.auth.signOut();
//     sessionStorage.removeItem('reAuthRequired');
//     sessionStorage.removeItem('cachedTotpSecret');
//   }

//   async register(name, email, password) {
//     await this.auth.createUserWithEmailAndPassword(email, password);
//     this.auth.currentUser.updateProfile({
//       displayName: name
//     });
//   }

//   getCurrentUsername() {
//     return this.auth.currentUser.displayName;
//   }
// }

// export default new Firebase();
//////////////////////////////////////////////////////////////////////////////////////////////
// import firebase from "../../config/fbConfig";
// import { loggedInProfileActions } from "../actions/loggedInProfileActions";
// import { LOGIN_SUCCESS, USER_LOGGED_IN } from "../actions/types";

// class Firebase {
//   constructor() {
//     this.auth = firebase.auth();
//     this.auth_ = firebase.auth;
//     this.database = firebase.database();
//   }

//   login(email, password) {
//     return this.auth.signInWithEmailAndPassword(email, password);
//   }

//   logOut() {
//     this.auth.signOut();
//     sessionStorage.removeItem('reAuthRequired');
//     sessionStorage.removeItem('cachedTotpSecret');
//   }

//   async register(name, email, password) {
//     await this.auth.createUserWithEmailAndPassword(email, password);
//     this.auth.currentUser.updateProfile({
//       displayName: name
//     });
//   }

//   getCurrentUsername() {
//     return this.auth.currentUser.displayName;
//   }
// }

// export default new Firebase();